import script from "./BusyLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BusyLoader.vue?vue&type=script&setup=true&lang=js"

import "./BusyLoader.vue?vue&type=style&index=0&id=244ded2e&scoped=true&lang=css"

import exportComponent from "/var/www/web/httpd/getsmartrx.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244ded2e"]])

export default __exports__